module.exports = __webpack_public_path__ + "static/media/image-courses-user-pro.a1b100a2.png";